import NoItemsPanel from './NoItemsPanel';

export default NoItemsPanel;
